import React from 'react';
import whyService from '../img/misc/misc-square-11.webp';
import chooseus from '../img/aboutus.jpg';

function WhyChooseUs() {
  return (
    <section id="why-choose-us" className="why-choose-us section">
      <div className="container section-title" data-aos="fade-up">
        <h2>Why Choose Us</h2>
        <div>
          <span>Why Choose </span>
          <span className="description-title">Our Services</span>
        </div>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row align-items-center">
          <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200">
            <div className="features-content">
              <h2>Why Choose Our Consulting Services</h2>
              <p className="lead">
                We deliver tailored electrical and power distribution solutions backed by years of experience, advanced engineering, and strict quality control.
              </p>
              <p>
                Our expert team ensures your systems are efficient, compliant, and future-ready—whether for industrial, commercial, or utility applications.
              </p>

              <div className="features-list">
                <div className="feature-item">
                  <div className="feature-icon">
                    <i className="bi bi-award"></i>
                  </div>
                  <div className="feature-text">
                    <h4>Certified electrical engineers and technicians</h4>
                  </div>
                </div>

                <div className="feature-item">
                  <div className="feature-icon">
                    <i className="bi bi-graph-up"></i>
                  </div>
                  <div className="feature-text">
                    <h4>Competitive pricing with flexible packages</h4>
                  </div>
                </div>

                <div className="feature-item">
                  <div className="feature-icon">
                    <i className="bi bi-clock-history"></i>
                  </div>
                  <div className="feature-text">
                    <h4>Fast delivery and nationwide installation</h4>
                  </div>
                </div>

                <div className="feature-item">
                  <div className="feature-icon">
                    <i className="bi bi-shield-check"></i>
                  </div>
                  <div className="feature-text">
                    <h4>Warranty-backed products</h4>
                  </div>
                </div>

                <div className="feature-item">
                  <div className="feature-icon">
                    <i className="bi bi-check-circle"></i>
                  </div>
                  <div className="feature-text">
                    <h4>Compliant with BSTI and IEC standards</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6" data-aos="fade-up" data-aos-delay="300">
            <div className="features-image">
              <div className="stats-card">
                <div className="stat-item">
                  <h3>
                    <span
                      data-purecounter-start="0"
                      data-purecounter-end="95"
                      data-purecounter-duration="1"
                      className="purecounter"
                    >95</span>%
                  </h3>
                  <p>Client Satisfaction</p>
                </div>
                <div className="stat-item">
                  <h3>
                    <span
                      data-purecounter-start="0"
                      data-purecounter-end="250"
                      data-purecounter-duration="1"
                      className="purecounter"
                    >250</span>+
                  </h3>
                  <p>Projects Completed</p>
                </div>
                <div className="stat-item">
                  <h3>
                    <span
                      data-purecounter-start="0"
                      data-purecounter-end="30"
                      data-purecounter-duration="1"
                      className="purecounter"
                    >30</span>+
                  </h3>
                  <p>Industry Awards</p>
                </div>
                <div className="stat-item">
                  <h3>
                    <span
                      data-purecounter-start="0"
                      data-purecounter-end="20"
                      data-purecounter-duration="1"
                      className="purecounter"
                    >20</span>+
                  </h3>
                  <p>Countries Served</p>
                </div>
              </div>
              <img
                src={chooseus}
                alt="Why Choose Us"
                className="img-fluid main-image"
                style={{height:'700px'}}
              />
              <div className="experience-badge">
                <div className="badge-content">
                  <span className="number">15+</span>
                  <span className="text">Years of Excellence</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;
